import React from "react";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GoalGroup from "./CategoryGroup";
// import { GoalLists } from "./CategoryLists";
import PolicyModal from "./PolicyModal";
import ViewPlan from "./ViewPlan";

import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "react-i18next";
import GameService from "../../service/GameService";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "./Main.scss";
import AllDataClass from "../common/AllDataClass";
import PolicyDetail from "./PolicyDetail";
import { SparkLineChart } from "@mui/x-charts/SparkLineChart";
import { ChartsReferenceLine } from "@mui/x-charts/ChartsReferenceLine";
import { lineElementClasses } from "@mui/x-charts/LineChart";
import DistoryedTower from "../../images/tower_distroyed.gif";
import HalfDistoryTower from "../../images/tower_half_distroyed.gif";
import Tower from "../../images/tower.gif";
import YoungSad from "../../images/young_sad.png";
import YoungHappy from "../../images/young_happy.png";
import OldSad from "../../images/old_sad.png";
import OldHappy from "../../images/old_happy.png";
import BgStorm from "../../images/weather_storm.png";
import BgFine from "../../images/weather_fine.png";
import BgBreeze from "../../images/weather_breeze.png";

const Main = (): JSX.Element => {
  const maxPolicyCnt = 8;
  const { t } = useTranslation();
  const [swiperHide, setSwiperHide] = useState(false);
  const [open, setOpen] = useState(false);
  const [openViewPlan, setOpenViewPlan] = useState(false);
  const [propData, setPropData] = useState({});
  const [selectedCnt, setSelectedCtn] = useState([]);
  const [selectedPolicyLists, setSelectedPolicyLists] = useState([]);
  const swiperRef = useRef(null);
  const { state } = useLocation();
  const [Category, setCategory] = useState([]);
  const [updateDebtRatio, setUpdateDebtRatio] = useState([]);
  const [tempDebtRatio, setTempDebtRatio] = useState([]);
  const [mouseOver, setMouseOver] = useState(false);
  const [debtLevel, setDebtLevel] = useState(1);
  const [averageBenefitPass, setAverageBenefitPass] = useState(false);
  const [lower40BenefitPass, setLower40BenefitPass] = useState(false);
  const [PYI1Pass, setPYI1Pass] = useState(false);
  const [showPolicies, setShowPolicies] = useState<any[]>(selectedPolicyLists);
  const [policyCnt, setPolicyCnt] = useState(0);
  const [pageCnt, setPageCnt] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [policyImpact, setPolicyImpact] = useState([]);
  const [policyModalOpen, setPolicyModalOpen] = useState(false);
  const [detailPolicy, setDetailPolicy] = useState({});
  const [detailPolicycategory, setDetailPolicyCategory] = useState("");
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [goalScore, setGoalScore] = useState([]);
  const [catIdx, setCategoryIdx] = useState(0);
  const [graphHeight, setGraphHeight] = useState(0);
  const [hideExplain, setHideExplain] = useState([]);
  const [hideDebtExplan, setHideDebtExplan] = useState(true);
  const [hidePYIExplan, setHidePYIExplan] = useState(true);
  const [fullMeetCnt, setFullMeetCnt] = useState(0);
  const [partialMeetCnt, setpartialMeetCnt] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const navigate = useNavigate();

  const graphRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const BaseGoalScore = AllDataClass.getBaseGoalScore();
  const AllPolicies = AllDataClass.getPolicyDescriptives();

  useEffect(() => {
    setGoalScore(BaseGoalScore);
  }, []);

  useEffect(() => {
    if (AllDataClass?.selectedList?.length > 0) {
      setSelectedPolicyLists([...AllDataClass.selectedList]);
    }
    var category = AllDataClass.getCategoryWithPoliciesCnt();
    console.log(category);
    setCategory(category);
    var explainLength = 0;
    category.forEach((cat: any[]) => {
      explainLength += cat.length;
    });
    setHideExplain([...Array(explainLength).fill(true)]);
    setSelectedGoals([...state.selectedGoals]);
    if (!graphRef.current) return;
    const resizeObserver = new ResizeObserver(() => {
      setGraphHeight(graphRef?.current?.clientHeight);
    });
    resizeObserver.observe(graphRef.current);
    return () => resizeObserver.disconnect(); // clean up
  }, []);
  useEffect(() => {
    if (swiperHide === true) {
      swiperRef.current.classList.add("hide");
    } else {
      swiperRef.current.classList.remove("hide");
    }
  }, [swiperHide]);

  useEffect(() => {
    setCategory(AllDataClass.getCategoryWithPoliciesCnt());
    var debtRatio = [];
    if (AllDataClass.selectedList?.length > 0) {
      debtRatio = AllDataClass.getBaseDebtRatiobyPolicy(AllDataClass.getSelectedList());
      // console.log(AllDataClass.getSelectedList());
      var goalscore = AllDataClass.getGoalScore();
      setGoalScore(goalscore);
      // 소득대체율 전체 50 이상이면 목표 달성
      if (goalscore[0] !== 0 && goalscore[0] - BaseGoalScore[0] > 0) {
        setAverageBenefitPass(true);
      } else {
        setAverageBenefitPass(false);
      }
      // 소들대체율 (1, 2분위) 40 이상이면 목표 달성
      if (goalscore[1] !== 0 && goalscore[1] - BaseGoalScore[1] > 0) {
        setLower40BenefitPass(true);
      } else {
        setLower40BenefitPass(false);
      }
      // PYI1이 31.8 이하면 목표 달성
      if (goalscore[2] !== 0 && goalscore[2] - BaseGoalScore[2] < 0) {
        setPYI1Pass(true);
      } else {
        setPYI1Pass(false);
      }
    } else {
      debtRatio = AllDataClass.getBaseDebtRatio();
      setGoalScore(BaseGoalScore);
      setAverageBenefitPass(false);
      setLower40BenefitPass(false);
      setPYI1Pass(false);
    }
    setUpdateDebtRatio(debtRatio);

    if (debtRatio[debtRatio.length - 1] > 180) {
      setDebtLevel(1);
    } else if (debtRatio[debtRatio.length - 1] > 150) {
      setDebtLevel(2);
    } else {
      setDebtLevel(3);
    }

    setPolicyCnt(selectedPolicyLists.length);
    var policycnt = selectedPolicyLists.length;
    var pagecnt = 0;
    if (policycnt >= maxPolicyCnt && policycnt % maxPolicyCnt == 0) {
      pagecnt = Math.floor(policycnt / maxPolicyCnt) - 1;
    } else {
      pagecnt = Math.floor(policycnt / maxPolicyCnt);
    }

    setPageCnt(pagecnt);
    var curpage = curPage;

    if (pagecnt < curPage) {
      curpage = pagecnt;
    }

    if (selectedPolicyLists.length > curpage * maxPolicyCnt) {
      var showlists = selectedPolicyLists.slice(
        curpage * maxPolicyCnt,
        curpage * maxPolicyCnt + maxPolicyCnt
      );
      setShowPolicies([...showlists]);
    }
    if (selectedPolicyLists.length <= 0) setShowPolicies([]);
    setPolicyImpact(AllDataClass.getPolicyGovGoalImpactsForGoals(selectedPolicyLists));
    setCurPage(curpage);
  }, [selectedPolicyLists]);

  useEffect(() => {
    if (mouseOver) {
      var selected = AllDataClass?.selectedList;
      var mousOverList: any = [];
      if (selected) mousOverList = [...selected];
      var conflictList = AllDataClass.getConflictPolicies(AllDataClass.mouseOverPolicy);
      var conflictPolicy = "";
      mousOverList.forEach((policy: string) => {
        if (conflictList.includes(policy)) {
          conflictPolicy = policy;
          return;
        }
      });
      mousOverList = mousOverList.filter((item: string) => item !== conflictPolicy);
      if (mousOverList.length > 0 && mousOverList.includes(AllDataClass.mouseOverPolicy)) {
        mousOverList = mousOverList.filter((item: string) => item !== AllDataClass.mouseOverPolicy);
      } else {
        mousOverList.push(AllDataClass.mouseOverPolicy);
      }
      setTempDebtRatio(AllDataClass.getBaseDebtRatiobyPolicy(mousOverList));
    }
  }, [mouseOver]);

  useEffect(() => {
    if (selectedPolicyLists.length > curPage * maxPolicyCnt) {
      var showlists = selectedPolicyLists.slice(
        curPage * maxPolicyCnt,
        curPage * maxPolicyCnt + maxPolicyCnt
      );
      setShowPolicies([...showlists]);
    }
  }, [curPage]);

  useEffect(() => {
    if (swiperInstance) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  const handleClose = () => {
    setOpen(false);
    setSwiperHide(false);
  };

  const handleViwPlanClose = () => {
    setOpenViewPlan(false);
    setSwiperHide(false);
  };

  const handleGo = () => {
    setOpen(false);
    setSwiperHide(false);
  };

  const handlerClosePolicyDetail = () => {
    setPolicyModalOpen(false);
  };

  const clickPrevBtn = () => {
    if (curPage > 0) {
      setCurPage(curPage - 1);
    }
    if (selectedPolicyLists.length > curPage * maxPolicyCnt) {
      setShowPolicies(selectedPolicyLists?.slice(0, maxPolicyCnt));
    }
  };

  const clickNextBtn = () => {
    if (curPage < pageCnt && curPage >= 0) {
      setCurPage(curPage + 1);
      if (selectedPolicyLists.length > curPage * maxPolicyCnt) {
        setShowPolicies(
          selectedPolicyLists?.slice(curPage * maxPolicyCnt, curPage * maxPolicyCnt + maxPolicyCnt)
        );
      } else {
        setCurPage(curPage - 1);
      }
    }
  };

  const baseDebtRatio = AllDataClass.getBaseDebtRatio();
  const optionsForGoals: any = {
    B005: ["소득세 인하", "법인세 인하", "상속세 폐지", "부동산세 폐지"],
    B007: ["소득대체율 (전체)", "소득대체율 (1,2분위)", "PYI", "나랏빚 비율"],
    B008: ["고등교육 확충", "법인세 인하"],
  };

  const showStarPoint = (goalID: string) => {
    var starPoint = 0;
    var isSuccessed = [];
    var lowerTax = ["P0015", "P0016", "P0017", "P0018"];
    var muchTax = ["P0011", "P0012", "P0013", "P0014"];
    var lowerCopTax = ["P0035", "P0036", "P0037", "P0038"];
    var muchCopTax = ["P0031", "P0032", "P0033", "P0034"];
    var otherTax = ["P0301", "P0311"];

    if (goalID === "B007") {
      isSuccessed.push(averageBenefitPass);
      isSuccessed.push(lower40BenefitPass);
      // PYI가 낮을 수록 노인 지원은 약해진다.
      isSuccessed.push(!PYI1Pass);
      isSuccessed.push(updateDebtRatio[updateDebtRatio.length - 1] <= 150);

      isSuccessed.forEach((success) => {
        if (success === true) {
          starPoint++;
        } else {
          starPoint--;
        }
      });
    } else if (goalID === "B005") {
      AllDataClass.selectedList.forEach((p1: string) => {
        lowerTax.forEach((p2) => {
          if (p1 === p2) {
            starPoint++;
            return;
          }
        });
        lowerCopTax.forEach((p2) => {
          if (p1 === p2) {
            starPoint++;
            return;
          }
        });
        muchTax.forEach((p2) => {
          if (p1 === p2) {
            starPoint--;
            return;
          }
        });
        muchCopTax.forEach((p2) => {
          if (p1 === p2) {
            starPoint--;
            return;
          }
        });
        otherTax.forEach((p2) => {
          if (p1 === p2) {
            starPoint++;
            return;
          }
        });
      });
    } else if (goalID === "B008") {
      AllDataClass.selectedList.forEach((p1: string) => {
        if (p1 === "P0191") {
          starPoint++;
        } else if (p1 === "P0192") {
          starPoint = starPoint + 2;
        } else {
          lowerCopTax.forEach((p2) => {
            if (p1 === p2) {
              starPoint = starPoint + 2;
              return;
            }
          });
          muchCopTax.forEach((p2) => {
            if (p1 === p2) {
              starPoint = starPoint - 2;
              return;
            }
          });
        }
      });
    }
    starPoint = 5;
    return (
      <>
        <div
          className="goal-star1"
          style={{
            visibility: starPoint >= 4 ? "visible" : "hidden",
          }}
        />
        <div
          className="goal-star2"
          style={{
            visibility: starPoint >= 2 ? "visible" : "hidden",
          }}
        />
        <div
          className="goal-star3"
          style={{
            visibility: starPoint >= 1 ? "visible" : "hidden",
          }}
        />
        <div
          className="goal-star4"
          style={{
            visibility: starPoint >= 3 ? "visible" : "hidden",
          }}
        />
        <div
          className="goal-star5"
          style={{
            visibility: starPoint >= 5 ? "visible" : "hidden",
          }}
        />
      </>
    );
  };

  const getGoalScore = () => {
    var points = new Array();
    selectedGoals.map((selectedGoal: any, idx: number) => {
      var starPoint = 0;
      var isSuccessed = [];
      // var lowerTax = ["P0015", "P0016", "P0017", "P0018"];
      // var muchTax = ["P0011", "P0012", "P0013", "P0014"];
      // var lowerCopTax = ["P0035", "P0036", "P0037", "P0038"];
      // var muchCopTax = ["P0031", "P0032", "P0033", "P0034"];
      var basicInsure = ["P0201", "P0202", "P0203", "P0204"];
      // 경제활성화 (B005) 별점 배열
      var B005P1 = [
        "P0015",
        "P0016",
        "P0017",
        "P0018",
        "P0035",
        "P0036",
        "P0037",
        "P0038",
        "P0301",
        "P0311",
        "P0701",
        "P0702",
        "P0703",
        "P0704",
      ];
      var B005M1 = [
        "P0011",
        "P0012",
        "P0013",
        "P0014",
        "P0031",
        "P0032",
        "P0033",
        "P0034",
        "P0071",
        "P0072",
        "P0081",
        "P0082",
        "P0704",
      ];
      var B007P1 = ["P0802"];
      var B007M1 = ["P0705", "P0801"];
      var B008P1 = ["P0191", "P0301", "P0311", "P0701", "P0702", "P0705", "P0803"];
      var B008P2 = ["P0192", "P0035", "P0036", "P0037", "P0038"];
      var B008M1 = ["P0071", "P0072", "P0081", "P0082", "P0802"];
      var B008M2 = ["P0031", "P0032", "P0033", "P0034"];
      // var otherTax = ["P0301", "P0311"];
      var goalID = selectedGoal.goalid;
      // var policy_list = new Array();

      if (goalID === "B007") {
        isSuccessed.push(averageBenefitPass);
        // 소득 1, 2분위는 별점 1개
        isSuccessed.push(lower40BenefitPass);
        isSuccessed.push(lower40BenefitPass);
        // PYI가 낮을 수록 노인 지원은 약해진다.
        isSuccessed.push(!PYI1Pass);
        isSuccessed.push(updateDebtRatio[updateDebtRatio.length - 1] <= 150);
        AllDataClass.selectedList?.forEach((p1: string) => {
          basicInsure.forEach((p2) => {
            if (p1 === p2) {
              isSuccessed.push(true);
            }
          });
          B007P1.forEach((p2) => {
            if (p1 === p2) {
              starPoint++;
            }
          });
          B007M1.forEach((p2) => {
            if (p1 === p2) {
              starPoint--;
            }
          });
        });

        isSuccessed?.forEach((success) => {
          if (success === true) {
            starPoint++;
            // } else {
            //   starPoint--;
          }
          if (updateDebtRatio[updateDebtRatio.length - 1] > 150) {
            starPoint--;
          }
        });
      } else if (goalID === "B005") {
        AllDataClass.selectedList?.forEach((p1: string) => {
          B005P1.forEach((p2) => {
            if (p1 === p2) {
              starPoint++;
            }
          });
          B005M1.forEach((p2) => {
            if (p1 === p2) {
              starPoint--;
            }
          });
        });
      } else if (goalID === "B008") {
        AllDataClass.selectedList?.forEach((p1: string) => {
          B008P1.forEach((p2) => {
            if (p1 === p2) {
              starPoint++;
            }
          });
          B008P2.forEach((p2) => {
            if (p1 === p2) {
              starPoint = starPoint + 2;
            }
          });
          B008M1.forEach((p2) => {
            if (p1 === p2) {
              starPoint--;
            }
          });
          B008M2.forEach((p2) => {
            if (p1 === p2) {
              starPoint = starPoint - 2;
            }
          });
        });
      }
      points.push(starPoint);
    });

    return points;
  };

  const GoalLists = () => {
    var goal_list = new Array();
    var points = getGoalScore();

    selectedGoals.map((selectedGoal: any, idx: number) => {
      var starPoint = points[idx];

      goal_list.push(
        <div className="goal-list" key={idx}>
          <div className="goal-list-inner-wrap">
            <div className="goal-info">
              <div className="goal-name">{selectedGoal.texts[0]}</div>
              {/* <div className="goal-policy-lists">{policy_list}</div> */}
            </div>
            <div className={`goal-image ${selectedGoal.goalid}`}></div>
          </div>
          {/* <div
            className="goal-star1"
            style={{
              visibility: starPoint >= 4 ? "visible" : "hidden",
            }}
          /> */}
          <div
            className="goal-star2"
            style={{
              visibility: starPoint >= 3 ? "visible" : "hidden",
            }}
          />
          <div
            className="goal-star1"
            style={{
              visibility: starPoint >= 1 ? "visible" : "hidden",
            }}
          />
          <div
            className="goal-star3"
            style={{
              visibility: starPoint >= 4 ? "visible" : "hidden",
            }}
          />
          {/* <div
            className="goal-star5"
            style={{
              visibility: starPoint >= 5 ? "visible" : "hidden",
            }}
          /> */}
        </div>
      );
    });

    return goal_list;
  };

  const viewPlainGoalList = () => {
    var goal_list = new Array();
    var points = getGoalScore();

    selectedGoals.map((selectedGoal: any, idx: number) => {
      var starPoint = points[idx];

      goal_list.push(
        <div className={`goal-image ${selectedGoal.goalid}`} key={idx}>
          {starPoint >= 1 && <div className="viewplan-goal-star1" />}
          {starPoint >= 3 && <div className="viewplan-goal-star2" />}
          {starPoint >= 4 && <div className="viewplan-goal-star3" />}
        </div>
      );
    });
    return goal_list;
  };

  const showPlan = () => {
    setSwiperHide(true);
    setOpenViewPlan(true);
  };

  const submitPlan = async () => {
    if (selectedPolicyLists?.length > 0) {
      try {
        GameService.createGame(
          AllDataClass.getGameId(),
          AllDataClass.getUserName(),
          JSON.stringify(selectedGoals),
          JSON.stringify(selectedPolicyLists),
          goalScore[2],
          JSON.stringify(updateDebtRatio),
          150,
          JSON.stringify(getGoalScore())
        );
        handleViwPlanClose();
        navigate("/result", {
          state: {
            selectedGoals: selectedGoals,
            gameid: AllDataClass.getGameId(),
            username: AllDataClass.getUserName(),
            debt: updateDebtRatio,
            selectedPolicyLists: selectedPolicyLists,
            starScore: getGoalScore(),
            pyi: goalScore[2],
          },
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      alert(t("nopolicyselected"));
    }
  };

  const closePlan = () => {
    setSwiperHide(false);
    setOpenViewPlan(false);
    setCurPage(0);
  };

  const handleCopyClipBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("copied");
    } catch (e) {
      alert("failed");
    }
  };
  const getGoalImpact = (policyid: any) => {
    var impact_list = new Array();
    if (selectedPolicyLists.length <= 0) return impact_list;
    selectedGoals.map((selectedGoal: any, idx: number) => {
      var goalIdx = Number(selectedGoal.goalid.substring(1));
      var impact = policyImpact[policyid][0][goalIdx];
      var classname = "";
      if (impact == 1) {
        classname = "smallup";
      } else if (impact == 2) {
        classname = "bigup";
      } else if (impact == -1) {
        classname = "smalldown";
      } else if (impact == -2) {
        classname = "bigdown";
      } else {
        classname = "none";
      }
      impact_list.push(
        <div className={`impact ${classname} ${selectedGoal.goalid}`} key={idx}></div>
      );
    });
    return impact_list;
  };
  const showSlectedPolicy = (policyid: string) => {
    var policy: any = {};
    policy[policyid] = AllDataClass.getPolicyDescriptivebyID(policyid);
    setDetailPolicy(policy);
    setDetailPolicyCategory(policy[policyid][0]);
    setPolicyModalOpen(true);
  };

  const checkGoalMeet = () => {
    var starScore = getGoalScore();
    var retVal = true;
    var fullmeet = 0;
    var partialmeet = 0;
    starScore.forEach((score) => {
      if (score >= 4) {
        retVal = retVal && true;
        fullmeet++;
        partialmeet++;
      } else if (score >= 3) {
        partialmeet++;
      } else {
        retVal = false;
      }
    });

    return (
      <div className="explains">
        {fullmeet == 3
          ? t("goal-full-meet-text")
          : partialmeet == 3
            ? t("goal-partial-meet-text")
            : t("goal-fail-text")}
      </div>
    );
    // return retVal;
  };
  return (
    <div
      className="game-main-root"
      style={{
        backgroundImage: `url(${debtLevel >= 3 ? BgFine : debtLevel >= 2 ? BgBreeze : BgStorm})`,
      }}
    >
      <PolicyDetail
        policyModalOpen={policyModalOpen}
        handleClose={handlerClosePolicyDetail}
        policy={detailPolicy}
        category={detailPolicycategory}
        selectedPolicyLists={selectedPolicyLists}
        setSelectedPolicyLists={setSelectedPolicyLists}
      />
      <div className="viewplan-modal" style={openViewPlan ? {} : { display: "none" }}>
        <div className="viewplan-background" />
        <div className="viewplan-modal-content">
          <div className="plan-explain">
            <div className="plan-explain-title">
              <span>{t("inprogress")}</span>
            </div>
            <div className="plan-explain-contents">
              <div className="row-wrap">
                <div className="bullet" />
                <div className="explains">
                  {t("debtgoal-text", {
                    debtratio: updateDebtRatio[updateDebtRatio?.length - 1]?.toFixed(1),
                    archive:
                      updateDebtRatio[updateDebtRatio.length - 1] > 150
                        ? t("archive-fail")
                        : t("archive-meet"),
                  })}
                </div>
              </div>
              <div className="row-wrap">
                <div className="bullet" />
                <div className="explains">
                  {t("PYI-text", {
                    pyi: goalScore[2]?.toFixed(1),
                    level:
                      goalScore[2] - 31.8 == 0
                        ? t("equal-pyi")
                        : goalScore[2] - 31.8 > 0
                          ? t("upper-pyi")
                          : t("lower-pyi"),
                    generation: goalScore[2] - 31.8 >= 0 ? t("future-gen") : t("current-gen"),
                  })}
                </div>
              </div>
              <div className="row-wrap">
                <div className="pyi-result-wrap">
                  <div className="pyi-result young">
                    <img
                      className="pyi-result-img"
                      src={PYI1Pass === true ? YoungHappy : YoungSad}
                    />
                  </div>
                  <div className="pyi-result old">
                    <img className="pyi-result-img" src={PYI1Pass === false ? OldHappy : OldSad} />
                  </div>
                </div>
              </div>
              <div className="row-wrap">
                <div className="bullet" />
                {checkGoalMeet()}
                {/* <div className="explains">
                  {checkGoalMeet() == true ? t("goal-meet-text") : t("goal-fail-text")}
                </div> */}
              </div>
            </div>
            <div className="plan-explain-id">
              <div className="saveid">
                SavelD:&nbsp;
                <span>{AllDataClass.getGameId()}</span>
              </div>
              <div
                className="btn-copy-id"
                onClick={() => handleCopyClipBoard(AllDataClass.getGameId())}
              ></div>
            </div>
          </div>
          <div className="plan-list">
            <div className="plan-list-title">
              <span>
                {AllDataClass.getUserName()}
                {t("userplan")}
              </span>
              <div className="plan-close-btn" onClick={closePlan} />
            </div>
            <div className="plan-lists">
              <div className="goal-wrap">
                <div className="goals">{viewPlainGoalList()}</div>
              </div>
              <div className="plans">
                {showPolicies.map((policyid: any, idx: number) => (
                  <div className="row" key={idx}>
                    <div
                      className="bullet"
                      onClick={() => {
                        showSlectedPolicy(policyid);
                      }}
                    ></div>
                    <div className="policyname">
                      {AllPolicies[policyid] && AllPolicies[policyid][2]}
                    </div>
                    <div className="impacts">{getGoalImpact(policyid)}</div>
                  </div>
                ))}
              </div>
              <div className="sub-buttons">
                <button
                  className="view-plan-prev"
                  disabled={curPage == 0}
                  onClick={() => clickPrevBtn()}
                />
                <button
                  className="view-plan-next"
                  disabled={curPage == pageCnt}
                  onClick={() => clickNextBtn()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <PolicyModal
        open={open}
        handleClose={handleClose}
        data={propData}
        catIdx={catIdx}
        selectedPolicyLists={selectedPolicyLists}
        setSelectedPolicyLists={setSelectedPolicyLists}
        setMouseOver={setMouseOver}
      />
      {/* <ViewPlan
        open={openViewPlan}
        handleClose={handleViwPlanClose}
        selectedGoals={selectedGoals}
        // selectedPolicyLists={selectedPolicyLists}
        // setSelectedPolicyLists={setSelectedPolicyLists}
      /> */}
      <div className="graph-wrap" ref={graphRef}>
        <div className="mark-wrap">
          <div className="goal-mark color-red" style={{ left: 20, top: graphHeight * 0.25 }}>
            <div className="mark-top"></div>
            <span className="mark-text">{t("debtlimit")}</span>
          </div>
          <div className="goal-mark color-gray" style={{ right: 28, top: graphHeight * 0.05 }}>
            <span className="mark-text">{t("current-trend")}</span>
            <div className="mark-bottom"></div>
          </div>
          {selectedPolicyLists?.length > 0 && (
            <div
              className="goal-mark color-red"
              style={{
                right: 160,
                top: graphHeight * (1 - updateDebtRatio[23] / 200),
                transform: "translate( 0, -100%)",
              }}
            >
              <span className="mark-text">{t("final-result")}</span>
              <div className="mark-bottom"></div>
            </div>
          )}
        </div>
        <SparkLineChart
          className="graph"
          data={updateDebtRatio}
          yAxis={{
            min: 0,
            max: 200,
          }}
          sx={{
            [`& .${lineElementClasses.root}`]: {
              strokeWidth: 4,
            },
          }}
          colors={["yellow"]}
        />
        <SparkLineChart
          className="graph"
          data={baseDebtRatio}
          sx={{
            [`& .${lineElementClasses.root}`]: {
              strokeWidth: 4,
            },
          }}
          yAxis={{
            min: 0,
            max: 200,
          }}
          colors={["white"]}
        >
          <ChartsReferenceLine
            y={150}
            label=""
            lineStyle={{ strokeDasharray: "10 5", strokeWidth: 4, stroke: "white" }}
          />
        </SparkLineChart>
        {mouseOver && (
          <SparkLineChart
            className="graph"
            data={tempDebtRatio}
            yAxis={{
              min: 0,
              max: 200,
            }}
            sx={{
              [`& .${lineElementClasses.root}`]: {
                strokeDasharray: "10 5",
                strokeWidth: 4,
                stroke: "yellow",
              },
            }}
            colors={["yellow"]}
          />
        )}
      </div>
      <div className="result">
        <div className="result-wrap">
          <div className="debt-result-wrap">
            <div className="debt-result">
              <img
                className="debt-result-img"
                src={debtLevel >= 3 ? Tower : debtLevel >= 2 ? HalfDistoryTower : DistoryedTower}
              />
            </div>
            <button
              className="exclamation-mark"
              onClick={() => {
                setHideDebtExplan(!hideDebtExplan);
                setHidePYIExplan(true);
              }}
            />
            {hideDebtExplan === false && (
              <div
                className="explain debt-explain"
                onClick={() => {
                  setHideDebtExplan(!hideDebtExplan);
                  setHidePYIExplan(true);
                }}
              >
                <span>{t("help-tower")}</span>
              </div>
            )}
          </div>
          <div className="pyi-results">
            <div className="pyi-result-wrap">
              <div className="pyi-result-back"></div>
              <div className="pyi-result young">
                <img className="pyi-result-img" src={PYI1Pass === true ? YoungHappy : YoungSad} />
              </div>
              <div className="pyi-result old">
                <img className="pyi-result-img" src={PYI1Pass === false ? OldHappy : OldSad} />
              </div>
            </div>
            <button
              className="exclamation-mark"
              onClick={() => {
                setHideDebtExplan(true);
                setHidePYIExplan(!hidePYIExplan);
              }}
            />
            {hidePYIExplan === false && (
              <div
                className="explain pyi-explain"
                onClick={() => {
                  setHideDebtExplan(true);
                  setHidePYIExplan(!hidePYIExplan);
                }}
              >
                <span>{t("help-pyi")}</span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="goal-list-wrap">{GoalLists()}</div>
      <Swiper
        loop={true}
        // autoplay={{
        //   delay: 10000,
        //   disableOnInteraction: false,
        // }}
        onSwiper={setSwiperInstance} // Store Swiper instance
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="myMainswiper"
        ref={swiperRef}
      >
        {Category.map((category: any[], idx: number) => (
          <SwiperSlide key={idx}>
            {category.map((cat, cidx) => (
              <GoalGroup
                key={cidx}
                idx={idx * 6 + cidx}
                data={cat[0]}
                selected={cat[5]}
                totalCnt={cat[4]}
                goalExplain={cat[7]}
                hideExplain={hideExplain}
                setHideExplain={setHideExplain}
                onClick={() => {
                  setSwiperHide(true);
                  setOpen(true);
                  setPropData(Category[idx][cidx]);
                  setCategoryIdx(idx * 6 + cidx);
                  setHideExplain(Array(hideExplain.length).fill(true));
                }}
              />
            ))}
          </SwiperSlide>
        ))}
        <div className="swiper-button-wrap">
          <button className="custom-button prev" ref={prevRef} />
          <button className="custom-button next" ref={nextRef} />
        </div>
      </Swiper>
      <div className="bottom-wrap">
        <div
          className="myplan"
          onClick={() => {
            showPlan();
          }}
        >
          <span>{t("myplan")}</span>
        </div>
        <div
          className={`submit-plan ${debtLevel >= 3 ? "blue" : ""}`}
          onClick={() => {
            submitPlan();
          }}
        >
          <span>{t("submit")}</span>
        </div>
      </div>
    </div>
  );
};

export default Main;
